import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "row-line" }, null, -1)
const _hoisted_2 = { class: "row-content p-field-checkbox" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "row-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setValue())),
    class: ["list-item-check", { 'listitem-disabled': _ctx.disabled }]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_Checkbox, {
          disabled: _ctx.disabled,
          inputId: _ctx.inputId,
          name: _ctx.name,
          modelValue: _ctx.modelValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue = $event)),
          value: _ctx.value,
          binary: _ctx.binary
        }, null, 8, ["disabled", "inputId", "name", "modelValue", "value", "binary"]),
        _renderSlot(_ctx.$slots, "checkbox-label", {}, () => [
          _createVNode("label", {
            class: "ml-2",
            for: _ctx.inputId
          }, _toDisplayString(_ctx.label), 9, ["for"])
        ])
      ]),
      _renderSlot(_ctx.$slots, "checkbox-sublabel")
    ]),
    (_ctx.last)
      ? (_openBlock(), _createBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}